const ENEA_GEST_API_URL      = 'https://agewebservice.frascati.enea.it/api/v1/';
const ENEA_GEST_BASE_URL = 'https://agewebservice.frascati.enea.it/';
const BDNCP_URL = 'https://dati.anticorruzione.it/superset/dashboard/dettaglio_cig/?cig=';

//const LISTA_1_BASE_PARAMS = encodeURIComponent("allegati/search?tag=Determina/Delibera di nomina del RUP e di indizione");
//const LISTA_2_BASE_PARAMS = encodeURIComponent("allegati/search?tag=Determina/Delibera aggiudicazione atto equivalente&ref_obj=esiti");
//const LISTA_3_BASE_PARAMS = encodeURIComponent("allegati/search?tag=Determina/Delibera aggiudicazione&ref_obj=esiti");
//const LISTA_4_BASE_PARAMS = encodeURIComponent("allegati/search?tag=Determina/Delibera aggiudicazione atto equivalente&ref_obj=lotti");


export {ENEA_GEST_API_URL, ENEA_GEST_BASE_URL, BDNCP_URL};